import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    'searchContainer',
    'filtersContainer',
    'taskTypesFilterContainer',
    'viewDetailsFilterContainer'
  ]

  connect() {
    const modulesContainer = document.getElementById('js-overview-modules-list');
    this.container = document.getElementById('js-overview-empty-state-card');
    this.boundCheckProgramModuleState = this._checkProgramModuleState.bind(this);
    this.boundShowTaskDependentFilters = this._showTaskDependentFilters.bind(this);
    this.boundCheckTaskDependentFilters = this._checkTaskDependentFilters.bind(this);

    modulesContainer.addEventListener('change', this.boundCheckProgramModuleState);
    document.addEventListener('promote:show-empty-state', this.boundCheckProgramModuleState);
    document.addEventListener('promote:task-created', this.boundShowTaskDependentFilters);
    document.addEventListener('promote:task-deleted', this.boundCheckTaskDependentFilters);

    this._checkProgramModuleState();
  }

  _checkProgramModuleState() {
    // get the modules container again in case of dynamic changes
    const modulesContainer = document.getElementById('js-overview-modules-list');

    if (modulesContainer.querySelectorAll('div').length === 0) {
      this._showEmptyStateMessageContainer();
      this._hideFilters();
    } else {
      this._showFilters();
    }
  }

  _showEmptyStateMessageContainer() {
    this.container.classList.remove('hidden');
  }

  _hideFilters() {
    this.searchContainerTarget.classList.add('hidden');
    this.filtersContainerTarget.classList.add('hidden');
  }

  _showFilters() {
    this.searchContainerTarget.classList.remove('hidden');
    this.filtersContainerTarget.classList.remove('hidden');
  }

  _showTaskDependentFilters() {
    if (this.hasTaskTypesFilterContainerTarget) {
      this.taskTypesFilterContainerTarget.classList.remove('hidden');
    }
    if (this.hasViewDetailsFilterContainerTarget) {
      this.viewDetailsFilterContainerTarget.classList.remove('hidden');
    }
  }

  _hideTaskDependentFilters() {
    if (this.hasTaskTypesFilterContainerTarget) {
      this.taskTypesFilterContainerTarget.classList.add('hidden');
    }
    if (this.hasViewDetailsFilterContainerTarget) {
      this.viewDetailsFilterContainerTarget.classList.add('hidden');
    }
  }

  _checkTaskDependentFilters(event) {
    const remainingTasksCount = event.detail?.remainingTasksCount;

    if (remainingTasksCount === 0) {
      this._hideTaskDependentFilters();
    }
  }
}
